import React from 'react';
import { IconProps } from '.';

const SvgCouponFillRounded = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M21 3a2 2 0 0 1 2 2v4a1 1 0 0 1-1 1c-1 0-2 1-2 2s1 2 2 2a1 1 0 0 1 1 1v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-4a1 1 0 0 1 1-1c1 0 2-1 2-2s-1-2-2-2a1 1 0 0 1-1-1V5a2 2 0 0 1 2-2h18Zm-6.5 10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm1.03-4.53a.75.75 0 0 0-1.06 0l-6 6a.75.75 0 1 0 1.06 1.06l6-6a.75.75 0 0 0 0-1.06ZM9.5 8a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCouponFillRounded;
